module.exports = __webpack_public_path__ + "imgesssyaa/svg/eolic-energy.d649c904.svg";